import React, { useState, useEffect } from 'react';
import GridContainer from '../../../../../@jumbo/components/GridContainer';
import AppTextInput from '../../../../../@jumbo/components/Common/formElements/AppTextInput';
import { Button, Dialog, Box, Grid, makeStyles, DialogTitle, DialogContent, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import { ADMIN, SADMIN } from '../../../../../config/config';
import { validarRutSeparado, validarMail } from '../../../../../@jumbo/utils/validaciones';
import { rutFormater } from '../../../../../@jumbo/utils/formaters';
import { CircularProgress } from '@material-ui/core';
import { CustomToast, toast } from '@jumbo/components/custom/Toast';
import { validacionRol } from '../../../../../services/service.user';
import { getNetworkMembers, updateUserWithNetwork } from 'services/api';
import DDLInput from '@jumbo/components/custom/Inputs/DDLInput';

const addStyle = makeStyles(theme => ({
  dialogRoot: {
    position: 'relative',
  },
  dialogTitleRoot: {
    '& .MuiTypography-h6': {
      fontSize: 16,
      color: theme.palette.common.dark,
    },
  },
}));

const defaultUser = {
  id: '',
  run: '',
  dv: '',
  names: '',
  last_name: '',
  mother_last_name: '',
  email: '',
  roles: [],
};

const UpdateUserDialog = props => {
  const logateUser = JSON.parse(sessionStorage.getItem('user'));
  const { openDialog = false, close, submit, rolesList = [], user = defaultUser, updateUser } = props;
  const classes = addStyle();
  // const [idU, setIdU] = useState('');
  const [run, setRun] = useState('');
  const [runError, setRunError] = useState('');
  const [dv, setDv] = useState('');
  const [dvError, setDvError] = useState('');
  const [names, setNames] = useState('');
  const [namesError, setNamesError] = useState('');
  const [lastName, setLastName] = useState('');
  const [lastNameError, setLastNameError] = useState('');
  const [motherLastName, setMotherLastName] = useState('');
  const [motherLastNameError, setMotherLastNameError] = useState('');
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [roles, setRoles] = useState([]);
  /*  const [rolesError, setRolesError] = useState(''); */
  /*   const [reloadRoles, setReloadRoles] = useState(true); */
  const [loading, setLoading] = useState(false);
  const [isNewUserNetwork, setIsNewUserNetwork] = useState("NO")
  const [nombrePrestadorEnRed, setNombrePrestadorEnRed] = useState('')
  const [nombrePrestadorEnRedError, setNombrePrestadorEnRedError] = useState('')
  const [listaPrestadoresDeRed, setListaPrestadoresDeRed] = useState([]);
  const [prestadoresRedCompleto, setPrestadoresRedCompleto] = useState([])

  useEffect(() => {
    if (user) {
      // setIdU(user.id);
      setRun(rutFormater(String(user.run)));
      setDv(String(user.dv));
      setNames(user.names);
      setLastName(user.last_name);
      setMotherLastName(user.mother_last_name);
      setEmail(user.email);
      setIsNewUserNetwork(user.is_network ? "SI" : "NO")
      setNombrePrestadorEnRed(user.organization.name)
      if (logateUser) {
        if (logateUser.organization.network_id) {
          getNetworkMembers(user.organization.network_id)
            .then(resNet => {
              let prestadores = resNet.data.members.map((item, index) => {
                return item.name
              })

              setListaPrestadoresDeRed(prestadores)
              setPrestadoresRedCompleto(resNet.data.members)
            })
            .catch(error => {

            })
            .finally(fin => {

            })
        }

        // let names = user.user_organizations.map((item) => { return item.name })
        // setListaPrestadoresDeRed(names)
      }
      var auxRoles = [];
      user.roles_user.forEach(element => {
        if (element.name !== SADMIN && element.name !== ADMIN) {
          auxRoles.push(rolesList.find(r => r.id === element.id));
        }
      });

      setRoles(auxRoles);
      /* setReloadRoles(false); */
    } else {
      // setIdU('');
      setRun('');
      setDv('');
      setNames('');
      setLastName('');
      setMotherLastName('');
      setEmail('');
      setRoles([]);
      setNombrePrestadorEnRed('')
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, rolesList]);

  const onCloseDialog = event => {
    if (loading) {
      event.preventDefault();
      return;
    }

    setLoading(false);
    setRun('');
    setDv('');
    setNames('');
    setLastName('');
    setMotherLastName('');
    setEmail('');
    setRoles([]);
    setNombrePrestadorEnRed('')
    setIsNewUserNetwork("NO")

    setRunError('');
    setDvError('');
    setNamesError('');
    setLastNameError('');
    setEmailError('');
    setNombrePrestadorEnRedError('')
    /*  setRolesError([]); */

    close();
  };

  const postRoles = () => {
    var auxRoles = [];
    auxRoles = roles.map(item => {
      return item.id;
    });
    if (user.roles_user.length) {
      if (validacionRol(SADMIN, user)) {
        auxRoles.push(user.roles_user.find(e => e.name === SADMIN).id);
      }
      if (validacionRol(ADMIN, user)) {
        auxRoles.push(user.roles_user.find(e => e.name === ADMIN).id);
      }
    }
    return auxRoles;
  };

  const handlerRun = e => {
    var val = e.target.value.split('.').join('');
    if (/^\d{0,8}$/g.test(val)) {
      setRun(rutFormater(val));
      setRunError('');
    }
  };

  const handlerDv = e => {
    var val = e.target.value;
    if (/^[\dkK]{0,1}$/g.test(val)) {
      setDv(val);
      setDvError('');
    }
  };

  const validate = () => {
    var res = true;
    if (!run) {
      setRunError('Debe ingresar un run');
      res = false;
    }
    if (!dv) {
      setDvError('falta dv');
      res = false;
    }
    if (!validarRutSeparado(run, dv)) {
      setDvError('no valido');
      res = false;
    }
    if (!names) {
      setNamesError('Debe ingresar al menos un nombre');
      res = false;
    }
    if (!lastName) {
      setLastNameError('Debe ingresar un primer Apellido');
      res = false;
    }
    if (!email) {
      setEmailError('Debe ingresar un correo electronico');
      res = false;
    }
    if (!validarMail(email)) {
      setEmailError('Correo no valido');
      res = false;
    }
    if (postRoles().length === 0) {
      /* setRolesError('Debe agregar al menos un rol'); */
      res = false;
    }
    return res;
  };

  const isActiveToBoolean = num => {
    if (num === 1) {
      return true;
    } else {
      return false;
    }
  };

  const getPrestadorId = (nombrePrestador) => {
    // let aux = user.user_organizations.find(e => e.name === nombrePrestador)
    let aux = prestadoresRedCompleto.find(e => e.name === nombrePrestador)
    console.log('prestador red', aux)
    return aux
  }

  const onSubmitClick = () => {
    setLoading(true);
    if (!validate()) {
      setLoading(false);
      return;
    }
    console.log('update',updateUser)
    console.log('usr',user)
    console.log('org', user.organization)


    var auxUser = {};
    auxUser.id = user.id;
    auxUser.run = Number(run.split('.').join(''));
    auxUser.dv = String(dv);
    auxUser.names = names;
    auxUser.last_name = lastName;
    auxUser.email = email;
    auxUser.is_network = isNewUserNetwork === "SI" ? true : false
    const auxId = getPrestadorId(nombrePrestadorEnRed)
    auxUser.organization_id = auxId.id
    const auxOrg = {
      code: auxId.code,
      name: auxId.name,
      network_id: user.organization.network_id,
      type_id: user.organization.type_id
    }
    // auxUser.organization = user.organization
    auxUser.organization = auxOrg



    auxUser.roles_user = postRoles();
    if (isNewUserNetwork === "SI") {
      auxUser.user_organizations = user.user_organizations
    } else {
      auxUser.user_organizations = []
    }
    if (motherLastName) {
      auxUser.mother_last_name = motherLastName;
    }
    auxUser.is_active = isActiveToBoolean(updateUser.is_active);
    auxUser.type_user = 'CU';

    updateUserWithNetwork(user.id, auxUser)
      .then(res => {
        toast.success('Usuario modificado correctamente.');
        onCloseDialog();
        submit();
      })
      .catch(err => {
        toast.error('Error al modificar usuario.');
      })
      .finally(f => {
        setLoading(false)
      })

  };

  const handleChangeNetwork = (event) => {
    setNombrePrestadorEnRed('');
    setNombrePrestadorEnRedError('')
    setIsNewUserNetwork(event.target.value);
  }

  return (
    <Dialog open={openDialog} onClose={onCloseDialog}>
      <CustomToast />
      <DialogTitle className={classes.dialogTitleRoot}> Modificar Usuario </DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
          <GridContainer>
            <Grid item xs={8} sm={8}>
              <AppTextInput
                fullWidth
                variant="outlined"
                label="Rut"
                value={run}
                onChange={event => handlerRun(event)}
                helperText={runError}
              />
            </Grid>
            <Grid item xs={4} sm={4}>
              <AppTextInput
                fullWidth
                variant="outlined"
                label="DV"
                value={dv}
                onChange={event => handlerDv(event)}
                helperText={dvError}
              />
            </Grid>
          </GridContainer>
        </Box>
        <Box mb={{ xs: 6, md: 5 }}>
          <AppTextInput
            fullWidth
            variant="outlined"
            label="Nombres"
            value={names}
            onChange={e => {
              setNames(e.target.value);
              setNamesError('');
            }}
            helperText={namesError}
          />
        </Box>
        <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
          <GridContainer>
            <Grid item xs={12} sm={6}>
              <AppTextInput
                fullWidth
                variant="outlined"
                label="Apellido Paterno"
                value={lastName}
                onChange={e => {
                  setLastName(e.target.value);
                  setLastNameError('');
                }}
                helperText={lastNameError}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <AppTextInput
                fullWidth
                variant="outlined"
                label="Apellido Materno"
                value={motherLastName}
                onChange={e => {
                  setMotherLastName(e.target.value);
                  setMotherLastNameError('');
                }}
                helperText={motherLastNameError}
              />
            </Grid>
          </GridContainer>
        </Box>

        <Box mb={{ xs: 6, md: 5 }}>
          <AppTextInput
            fullWidth
            variant="outlined"
            label="Correo Electronico"
            value={email}
            onChange={e => {
              setEmail(e.target.value);
              setEmailError('');
            }}
            helperText={emailError}
          />
        </Box>
        {logateUser.is_network ? (
          <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
            <GridContainer>
              <Grid item xs={6} sm={6}>
                <FormControl>
                  <FormLabel id="demo-row-radio-buttons-group-label">Ver reclamos de toda la red</FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={isNewUserNetwork}
                    onChange={handleChangeNetwork}>
                    <FormControlLabel value="SI" control={<Radio />} label="Si" />
                    <FormControlLabel value="NO" control={<Radio />} label="No" />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={6}>
                <DDLInput

                  //style="font-size:8pt"
                  label="Nombre Prestador"
                  value={nombrePrestadorEnRed}
                  lista={listaPrestadoresDeRed}
                  onChange={res => {
                    setNombrePrestadorEnRed(res);
                    setNombrePrestadorEnRedError('');

                  }}
                  onSelect={listIndex => {
                    setNombrePrestadorEnRed(listaPrestadoresDeRed[listIndex]);
                    setNombrePrestadorEnRedError('');

                  }}
                  error={nombrePrestadorEnRedError}
                />
              </Grid>
            </GridContainer>
          </Box>
        ) : null}

        {/*         <Box mb={{ xs: 6, md: 4 }}>
          <Box>
            <CmtDropdownMenu
              items={rolesList}
              onItemClick={menu => {
                handleRol(menu);
              }}
              TriggerComponent={
                <Button variant="outlined" color="primary" onClick={() => {}}>
                  Agregar Rol
                </Button>
              }
            />
            <ErrorLabel content={rolesError} />
          </Box>
        </Box>
        {roles.length > 0 ? (
          <Box mb={{ xs: 3, md: 3 }}>
            {roles.map(item => {
              if (item === undefined) {
                return null;
              } else {
                return (
                  <Chip
                    key={`Chip-${item.id}`}
                    label={item.label}
                    style={{ margin: '4px' }}
                    onDelete={() => {
                      handleRol(item);
                    }}
                  />
                );
              }
            })}
          </Box>
        ) : null} */}
        <Box display="flex" justifyContent="flex-end" mb={4}>
          <Button onClick={onCloseDialog} disabled={loading}>
            &nbsp;Cancelar&nbsp;
          </Button>
          <Box ml={2}>
            <Button variant="outlined" color="primary" onClick={onSubmitClick} disabled={loading}>
              {loading ? <CircularProgress color="inherit" style={{ height: '22px', width: '22px' }} /> : 'Modificar'}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default UpdateUserDialog;
